import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { ProfileStoryData } from "../Data/ProfileStoryData";

const ProfileHeader = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [modalImages, setModalImages] = useState([]);
  const [loadingImages, setLoadingImages] = useState(true); // 로딩 상태 추가

  const openModal = (imgSrc, images) => {
    setSelectedImage(imgSrc);
    setCurrentImageIndex(images.indexOf(imgSrc));
    setModalImages(images);
    setLoadingImages(true); // 모달 열기 시 로딩 상태 활성화
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setLoadingImages(true); // 모달 닫기 시 로딩 상태 초기화
  };

  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = "hidden"; // 모달이 열리면 스크롤 비활성화
    } else {
      document.body.style.overflow = "auto"; // 모달이 닫히면 스크롤 활성화
    }

    return () => {
      document.body.style.overflow = "auto"; // 컴포넌트 언마운트 시 스크롤 활성화 (클린업)
    };
  }, [isModalOpen]);

  useEffect(() => {
    if (!isModalOpen) return;

    // 모든 이미지가 로드되었는지 확인
    const handleImageLoad = () => {
      // 이미지 로드 후 로딩 상태를 false로 변경
      setLoadingImages(false);
    };

    // 모달이 열리면 로딩 상태 초기화
    const images = document.querySelectorAll(".modal-image");
    if (images.length === 0) {
      setLoadingImages(false);
    } else {
      images.forEach((img) => {
        if (img.complete) {
          handleImageLoad();
        } else {
          img.addEventListener("load", handleImageLoad);
          img.addEventListener("error", handleImageLoad); // 오류 처리 추가
        }
      });
    }

    return () => {
      // Clean up event listeners
      images.forEach((img) => {
        img.removeEventListener("load", handleImageLoad);
        img.removeEventListener("error", handleImageLoad);
      });
    };
  }, [isModalOpen]);

  return (
    <ProfileHeaderWrap>
      <ProfileHeaderTopBox>
        <div className="profilePictureBox">
          <img
            src="https://dongsooo.github.io/imgs/dongstgram_img/06_profile_img_01.jpg"
            alt="프로필 이미지"
          />
        </div>
        <div className="profileInfoBox">
          <div className="profileIDBox">
            <p className="profileName">dongsu</p>
          </div>
          <div className="profileContentsNumsBox">
            <p>
              게시물 <span>183</span>
            </p>
            <p>
              팔로워 <span>201</span>
            </p>
            <p>
              팔로우 <span>125</span>
            </p>
          </div>
          <div className="profileCommentBox">
            <p>동스타그램에 오실 것을 환영합니다.</p>
          </div>
        </div>
      </ProfileHeaderTopBox>
      <ProfileHeaderBottomBox>
        <ul>
          {ProfileStoryData.map((data) => (
            <StoryItem
              key={data.id}
              images={data.imgSrc}
              title={data.title}
              openModal={openModal}
            />
          ))}
        </ul>
      </ProfileHeaderBottomBox>

      {isModalOpen && (
        <ModalOverlay onClick={closeModal}>
          <ModalContent onClick={(e) => e.stopPropagation()}>
            {loadingImages && <LoadingScreen>loading...</LoadingScreen>}{" "}
            {/* 로딩 화면 추가 */}
            <ModalSlider
              images={modalImages}
              currentIndex={currentImageIndex}
              setCurrentIndex={setCurrentImageIndex}
              onImageLoad={() => setLoadingImages(false)} // 이미지 로드 시 핸들러
            />
          </ModalContent>
        </ModalOverlay>
      )}
    </ProfileHeaderWrap>
  );
};

const StoryItem = ({ images, title, openModal }) => {
  return (
    <li>
      <SliderWrapper>
        <img
          src={images[0]}
          alt={title}
          onClick={() => openModal(images[0], images)}
        />
      </SliderWrapper>
      <p>{title}</p>
    </li>
  );
};

const ModalSlider = ({
  images,
  currentIndex,
  setCurrentIndex,
  onImageLoad,
}) => {
  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const handlePrev = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  return (
    <SliderWrapper>
      {images.length > 1 && (
        <ArrowButton onClick={handlePrev}>{"<"}</ArrowButton>
      )}
      <img
        src={images[currentIndex]}
        alt="Modal"
        className="modal-image"
        onLoad={onImageLoad} // 이미지가 로드될 때 호출
      />
      {images.length > 1 && (
        <ArrowButton onClick={handleNext}>{">"}</ArrowButton>
      )}
    </SliderWrapper>
  );
};

export default ProfileHeader;

// Styled Components

const ProfileHeaderWrap = styled.div`
  width: 100%;
  min-width: 360px;
`;

const ProfileHeaderTopBox = styled.div`
  width: 935px;
  height: 180px;
  margin: 0 auto;
  padding-top: 50px;
  display: flex;

  @media (max-width: 1264px) {
    max-width: 935px;
    width: 100%;
  }

  .profilePictureBox {
    width: 283px;
    height: 100%;
    position: relative;

    @media (max-width: 767px) {
      width: 140px;
      height: 140px;
    }

    img {
      width: 150px;
      height: 150px;
      border-radius: 50%;

      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      @media (max-width: 767px) {
        width: 120px;
        height: 120px;
      }
    }
  }

  .profileInfoBox {
    flex: 1;

    .profileIDBox {
      .profileName {
        font-size: 1.5em;
        margin: 10px;
      }
    }

    .profileContentsNumsBox {
      display: flex;

      @media (max-width: 767px) {
        flex-direction: column;
      }
      p {
        margin: 10px;
        padding-right: 5px;
        @media (max-width: 767px) {
          margin: 1px 0px 1px 10px;
        }
        span {
          font-weight: bold;
        }
      }
    }
  }

  .profileCommentBox {
    p {
      margin: 10px;
      font-weight: bold;
      font-size: 1em;
      @media (max-width: 767px) {
        font-size: 0.8em;
      }
    }
  }
`;

const ProfileHeaderBottomBox = styled.div`
  width: 100%;
  height: 174px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;

  @media (max-width: 767px) {
    max-width: 767px;
    width: 100%;
    height: 80px;
    margin-bottom: 2em;
  }

  ul {
    width: 935px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-around;
    gap: 40px;
    min-width: 360px;

    @media (max-width: 767px) {
      max-width: 767px;
      width: 96%;
      gap: 10px;
    }

    li {
      width: 87px;
      height: 87px;
      border-radius: 50%;

      position: relative;
      cursor: pointer;

      @media (max-width: 767px) {
        width: 70px;
        height: 70px;
      }

      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 50%;
      }

      p {
        position: absolute;
        width: 100%;
        text-align: center;
        bottom: -35%;
        left: 50%;

        transform: translateX(-50%);
      }
    }
  }
`;

const SliderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 100%;
`;

const ArrowButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  color: white;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;

  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:first-child {
    left: 10px;
  }

  &:last-child {
    right: 10px;
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 90%;
  max-height: 80%;
  position: relative;

  img {
    max-width: 100%;
    max-height: 70vh;
  }
`;

const LoadingScreen = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 2em;
  color: #333;
  z-index: 1001;
`;
